export default __webpack_public_path__ + "media/images/logo/sns/facebook_blue-5469e1a7f27d9e7ce9b95d19fc1e8df6.png";